const storage = sessionStorage; // For auth token and other session-specific data

export const storageHelper = {
    get: (key, defaultValue = null) => {
        try {
            const item = storage.getItem(key);
            if (!item) return defaultValue;
            
            // Always try to parse stored items
            try {
                return JSON.parse(item);
            } catch {
                return item;
            }
        } catch {
            return defaultValue;
        }
    },

    set: (key, value) => {
        try {
            const valueToStore = typeof value === 'object' 
                ? JSON.stringify(value) 
                : value;
            storage.setItem(key, valueToStore);
        } catch (error) {
            console.error('Storage set error:', error);
        }
    },

    clear: () => {
        storage.clear();
        // Also clear localStorage items related to units
        localStorage.removeItem('units');
        localStorage.removeItem('activeUnit');
    }
};